import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import GalleryPage from "../pages/gallery/page";
import ContactPage from "../pages/contact/page";
import UrbanInfraProjectsPage from "../pages/urbaninfra/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/urbaninfra",
    element: <UrbanInfraProjectsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
